module.exports = __webpack_public_path__ + "static/adidas-preroll-84d292dc826d98bed9cc9690dceb8202.jpg";